export default "__VITE_ASSET__B4nNg0Wy__"